import React from 'react';
import StatusBadge from './StatusBadge';
import { cx, resolveLegendDotClass, standardizeZoneSeverityLabel, valueToneClasses } from '../theme';

export default function ZoneKpiCard({ item }) {
  const badgeTone = item.badge?.tone || item.severity;

  return (
    <article
      data-coo="kpi-card"
      className="kpi-card-wrapper flex h-full flex-col"
    >
      <div data-coo="kpi-domain-tag" className="kpi-label mb-2">
        <span className={cx('kpi-dot', resolveLegendDotClass(item.domainTag))} />
        <span className="truncate">{item.domainTag}</span>
      </div>
      <div
        data-coo="kpi-label"
        className="min-h-[2.5rem] text-[12px] font-semibold leading-6 text-slate-700"
      >
        {item.label}
      </div>
      <div
        data-coo="kpi-value"
        className={cx('kpi-value mt-2', valueToneClasses[item.severity] || valueToneClasses.neutral)}
      >
        {item.value}
      </div>
      <div data-coo="kpi-subtext" className="kpi-sub mt-2 flex-1 text-slate-500">
        {item.subtext}
      </div>
      <StatusBadge tone={badgeTone} className="mt-3 self-start">
        {standardizeZoneSeverityLabel(badgeTone)}
      </StatusBadge>
    </article>
  );
}
